var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-divider',[_vm._v("福州视通传媒有限公司提供技术支持")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }